import { useParams } from '@tanstack/react-router';
import { PurchaseOrderLayout } from '@/features/purchase-order/layout/purchase-order-layout';
import { AppLayout } from '@/layouts/app-layout';

export function PurchaseOrderPage() {
  const { id } = useParams({ strict: false });

  return (
    <AppLayout>
      <PurchaseOrderLayout purchaseOrderId={`${id}`} />
    </AppLayout>
  );
}
